import * as TYPES from "./types";
import data from "../data";
import data2 from "../data2.json";

function update_localstorage_data(old_data, new_data) {
  for (let i = 0; i < new_data.length; i++) {
    new_data[i].solved = old_data[i].solved;
    new_data[i].favourite = old_data[i].favourite;
  }
}

export const fetch_Questions = () => async (dispatch, store) => {
  try {
    let current_sheet = localStorage.getItem("current_sheet");
    if (!current_sheet) {
      localStorage.setItem("current_sheet", "questions");
      current_sheet = "questions";
    }
    const question_store = store();
    const version = question_store.questions.version;
    const localStorage_data = localStorage.getItem(current_sheet);
    if (
      localStorage.getItem(current_sheet) === null ||
      localStorage.getItem("version") === null ||
      localStorage.getItem("version") < version
    ) {
      if (current_sheet === "questions") {
        if (localStorage_data) {
          update_localstorage_data(JSON.parse(localStorage_data), data);
        }
        localStorage.setItem(current_sheet, JSON.stringify(data));
      } else if (current_sheet === "questions2") {
        if (localStorage_data) {
          update_localstorage_data(JSON.parse(localStorage_data), data2.data);
        }
        localStorage.setItem(current_sheet, JSON.stringify(data2.data));
      }
      localStorage.setItem("version", version);
    }
    const raw_data = localStorage.getItem(current_sheet);
    const parsed_data = JSON.parse(raw_data);
    dispatch({
      type: TYPES.FETCH_QUESTIONS,
      payload: parsed_data,
    });
  } catch (error) {
    console.log(error);
  }
};

export const update_solved = (id, solved) => async (dispatch, store) => {
  try {
    const all_questions = store().questions.question_list;
    let current_sheet = localStorage.getItem("current_sheet");
    const new_list = all_questions.map((q) => {
      if (q.id === id) {
        q.solved = !solved;
      }
      return q;
    });
    localStorage.removeItem(current_sheet);
    localStorage.setItem(current_sheet, JSON.stringify(new_list));
    dispatch({
      type: TYPES.UPDATE_SOLVED,
      payload: new_list,
    });
  } catch (error) {
    console.log(error);
  }
};

export const update_filter_fav = (val) => async (dispatch) => {
  try {
    dispatch({
      type: TYPES.UPDATE_FILTER_FAV,
      payload: val,
    });
  } catch (error) {
    console.log(error);
  }
};

export const update_filter_topic = (val) => async (dispatch) => {
  try {
    dispatch({
      type: TYPES.UPDATE_FILTER_TOPIC,
      payload: val,
    });
  } catch (error) {
    console.log(error);
  }
};

export const update_filter_solved = (val) => async (dispatch) => {
  try {
    dispatch({
      type: TYPES.UPDATE_FILTER_SOLVED,
      payload: val,
    });
  } catch (error) {
    console.log(error);
  }
};

export const update_search_string = (val) => async (dispatch) => {
  try {
    dispatch({
      type: TYPES.UPDATE_SEARCH_STRING,
      payload: val,
    });
  } catch (error) {
    console.log(error);
  }
};

export const update_favourite = (id) => async (dispatch, store) => {
  try {
    const all_questions = store().questions.question_list;
    const new_list = all_questions.map((q) => {
      if (q.id === id) {
        q.favourite = !q.favourite;
      }
      return q;
    });
    let current_sheet = localStorage.getItem("current_sheet");
    localStorage.removeItem(current_sheet);
    localStorage.setItem(current_sheet, JSON.stringify(new_list));
    dispatch({
      type: TYPES.UPDATE_SOLVED,
      payload: new_list,
    });
  } catch (error) {
    console.log(error);
  }
};

export const change_sheet = (new_sheet) => async (dispatch, store) => {
  try {
    localStorage.setItem("current_sheet", new_sheet);
    fetch_Questions()(dispatch, store);
  } catch (error) {
    console.log(error);
  }
};
